import { render, staticRenderFns } from "./DebitPrice.vue?vue&type=template&id=8c85eaee&scoped=true&"
import script from "./DebitPrice.vue?vue&type=script&lang=js&"
export * from "./DebitPrice.vue?vue&type=script&lang=js&"
import style0 from "./DebitPrice.vue?vue&type=style&index=0&id=8c85eaee&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c85eaee",
  null
  
)

export default component.exports